import 'ol/ol.css';
import 'ol-layerswitcher/src/ol-layerswitcher.css'
import 'ol-popup/src/ol-popup.css'
import './MapPanel.css';

import React from 'react';

import { Map, View } from 'ol';
import { Control, defaults as defaultControls, MousePosition } from 'ol/control';
import { createStringXY } from 'ol/coordinate';
import { GeoJSON } from 'ol/format';
import { Draw, Modify, Select } from 'ol/interaction';
import { Group as LayerGroup, Image, Vector } from 'ol/layer';
import TileLayer from 'ol/layer/Tile';
import { BingMaps, ImageStatic, Vector as VectorSource, XYZ as XYZSource } from 'ol/source';
import { Projection } from 'ol/proj';
import { Circle, Fill, Stroke, Style, Text } from 'ol/style';
import LayerSwitcher from 'ol-layerswitcher';
import XMLParser from 'react-xml-parser';
import Popup from 'ol-popup';

import { appConfig } from '../config.js';
import axios from 'axios';
import vanu from '../apis/vanu';


class MapPanel extends React.Component {

    constructor(props) {
        super(props);

        // controls

        var mousePositionControl = new MousePosition({
            coordinateFormat: createStringXY(4),
            projection: 'EPSG:4326',
            target: document.getElementById('mouse-position'),
            undefinedHTML: '&nbsp;'
        });

        var parent = this;

        var EditControl = /*@__PURE__*/(function (Control) {
            function EditControl(opt_options) {
                var options = opt_options || {};
                var button = document.createElement('button');
                button.className = 'ui icon button mini edit-control ol-unselectable ol-control';
                button.setAttribute('data-position', 'bottom left');
                button.setAttribute('data-tooltip', 'Click here to create a new feature');
                button.setAttribute('data-inverted', '');
                button.setAttribute('data-tut', 'reactour__map__edit');
                var ielm = document.createElement('i');
                ielm.className = 'edit icon';
                button.append(ielm);
                var element = document.createElement('div');
                element.appendChild(button);

                Control.call(this, {
                    element: element,
                    target: options.target
                });
                button.addEventListener('click', parent.activateEditing.bind(this), false);
            }
            if (Control) EditControl.__proto__ = Control;
            EditControl.prototype = Object.create(Control && Control.prototype);
            EditControl.prototype.constructor = EditControl;
            return EditControl;
        }(Control));

        var SelectControl = /*@__PURE__*/(function (Control) {
            function SelectControl(opt_options) {
                var options = opt_options || {};
                var button = document.createElement('button');
                button.className = 'ui icon button mini info-control ol-control';
                button.setAttribute('data-position', 'bottom left');
                button.setAttribute('data-tooltip', 'Click here to select a site');
                button.setAttribute('data-inverted', '');
                button.setAttribute('data-tut', 'reactour__map__select');
                var ielm = document.createElement('i');
                ielm.className = 'info icon';
                button.append(ielm);
                var element = document.createElement('div');
                element.appendChild(button);
                Control.call(this, {
                    element: element,
                    target: options.target
                });
                button.addEventListener('click', parent.activateSelect.bind(this), false);
            }
            if (Control) SelectControl.__proto__ = Control;
            SelectControl.prototype = Object.create(Control && Control.prototype);
            SelectControl.prototype.constructor = SelectControl;
            return SelectControl;
        }(Control));

        // base layers
        var base_layers = [];

        // mapbox
        const mb_elevation = new TileLayer({
            title: 'MapBox Terrain',
            type: 'base',
            vanu_type: 'base',
            source: new XYZSource({
                url: `https://api.mapbox.com/v4/mapbox.mapbox-terrain-v2/{z}/{x}/{y}.pngraw?access_token=${appConfig.mapPanel.MAPBOX_MAP_KEY}`,
                crossOrigin: 'anonymous'
            })
        });
        base_layers.push(mb_elevation);

        // bing
        const bing_layers = [
            ['Road', 'Bing Roads'],
            ['CanvasDark', 'Bing Canvas Dark'],
            ['CanvasGray', 'Bing Canvas Gray'],
            ['CanvasLight', 'Bing Canvas Light'],
            ['AerialWithLabels', 'Bing Aerial with Labels'],
            ['Aerial', 'Bing Aerial']
        ];

        bing_layers.forEach((layer) => {
            const bing_layer = new TileLayer({
                title: layer[1],
                type: 'base',
                source: new BingMaps({
                    imagerySet: layer[0],
                    key: appConfig.mapPanel.BING_MAP_KEY
                }),
                visible: false
            });
            base_layers.push(bing_layer);
        });

        var mapSelectControl = new SelectControl();
        var mapEditControl = new EditControl();
        var map = new Map({
            controls: defaultControls().extend([mousePositionControl, mapEditControl, mapSelectControl]),
            target: document.getElementById('map'),
            layers: base_layers,
            view: new View({
                center: [0, 0],
                projection: 'EPSG:4326',
                zoom: 2
            })
        });
        map.selectControl = mapSelectControl;
        map.editControl = mapEditControl;

        var popup = new Popup();
        map.addOverlay(popup);
        map.popup = popup;

        var layerSwitcher = new LayerSwitcher({
            tipLabel: 'Legende',
            groupSelectStyle: 'children'
        });
        layerSwitcher.element.setAttribute('data-tut', 'reactour__layerswitcher')

        map.addControl(layerSwitcher);

        this.state = {
            map: map,
            editingEnabled: false,
            action: 'select'
        }

    }

    getPointStyle(rgbaFill, rgbaStroke, displayLabels=false) {
        return new Style({
            image: new Circle({
                radius: 5,
                fill: new Fill({ color: `rgba(${rgbaFill.r},${rgbaFill.g},${rgbaFill.b},${rgbaFill.a})` }),
                stroke: new Stroke({
                    color: [rgbaStroke.r, rgbaStroke.g, rgbaStroke.b], width: 2
                })
            }),
            text: new Text({
                font: '16px snas-serif',
                offsetY: -15,
                text: '',
                fill: new Fill({
                    color: 'white',
                }),
            }),
        })
    }

    addCollection(collection_version_id) {

        var map = this.state.map;
        map.setTarget('map');

        // remove all layers but "base" layers
        this.removeLayers(map, 'vector-collection');
        this.removeCoverageMap(map);

        // remove interactions and disable editing
        this.removeInteractions(map);
        if (map.select_interaction) {
            map.removeInteraction(map.select_interaction);
        }

        var vectorSource = new VectorSource({
            format: new GeoJSON(),
            url: `${appConfig.api.URL}/collectionversions/${collection_version_id}/geojson`
        });

        const sitesColor = this.props.configuration ? this.props.configuration.map_options.sites.color : { r: 0, g: 0, b: 255 };
        const displayLabels = this.props.configuration ? this.props.configuration.map_options.sites.display_labels : true;
        const vectorLayerStyle = this.getPointStyle(sitesColor, { r: 255, g: 255, b: 255 }, displayLabels);

        var vectorLayer = new Vector({
            title: 'Sites Collection',
            type: 'vector-collection',
            source: vectorSource,
            style: (feat, res) => {
                if(displayLabels){
                    vectorLayerStyle.getText().setText(feat.get('name'));
                }
                return vectorLayerStyle;
            }
        });

        var parent = this;

        vectorSource.on('change', function (e) {
            if (vectorSource.getState() === 'ready') {
                var extent = [0, 0, 180, 180];
                if (vectorSource.getFeatures().length > 0) {
                    extent = vectorSource.getExtent();
                    if (parent.state.action !== 'editing') {
                        map.getView().fit(extent, { "maxZoom": 11 });
                    }
                }
            }
        });

        map.addLayer(vectorLayer);
        map.vectorLayer = vectorLayer;

        var select = new Select({
            style: this.getPointStyle({ r: 255, g: 255, b: 0, a: 1 }, { r: 255, g: 255, b: 255 })
        });
        map.addInteraction(select);
        map.select_interaction = select;

        select.on('select', function (e) {
            if (e.target.getFeatures().getLength() > 0) {
                const feature = e.target.getFeatures().getArray()[0];
                const feat_id = feature.get('pk');
                console.log(feature);
                const infoBox = `
                <div>
                    <h6>Site: ${feature.get('name')}</h6>
                    <ul>
                        <li>Longitude: ${feature.get('geometry').flatCoordinates[0].toLocaleString()}</li>
                        <li>Latitude: ${feature.get('geometry').flatCoordinates[1].toLocaleString()}</li>
                        <li>Height: ${feature.get('height_local')} (meters)</li>
                        <li>Transmit Power: ${feature.get('height_local')} (meters)</li>
                        <li>Population: ${feature.get('population') ? feature.get('population').toLocaleString() : 'N/A'}</li>
                        <li>Type: ${feature.get('is_sector') ? 'Sectored (' + feature.get('azimuths') + ' °)' : 'Omni'}</li>
                    </ul>
                </div>
                `
                map.popup.show(feature.get('geometry').flatCoordinates,
                    infoBox);
                parent.props.onSetActiveFeature(parseInt(feat_id));
            }
        });

        this.setState({
            map: map,
            editingEnabled: false,
            action: 'add-collection'
        });

        // only display the active process if it is for the same collection!
        if (this.props.activeProcess && this.props.activeProcess.collection === collection_version_id) {
            this.displayProcess(this.props.activeProcess);
        }


    }

    removeInteractions = (map) => {
        // let's remove old interactions
        if (map.interactionModify) {
            map.removeInteraction(map.interactionModify);
            map.removeInteraction(map.interactionDraw);
        }
    }

    activateSelect = () => {
        console.log('selection is active');
        this.setState({
            editingEnabled: false,
            action: 'select'
        });
    }

    activateEditing = () => {

        var map = this.state.map;
        var vectorSource = map.vectorLayer.getSource();
        var action = 'editing';

        if (this.state.editingEnabled) {
            console.log('de-activating editing...');
            action = 'select';
            this.removeInteractions(map);
        } else {
            console.log('editing is active');
            var modify = new Modify({ source: vectorSource });
            map.addInteraction(modify);
            map.interactionModify = modify;
            var draw;
            draw = new Draw({
                source: vectorSource,
                type: 'Point'
            });
            map.addInteraction(draw);
            map.interactionDraw = draw

            draw.on('drawend', (e) => {
                e.preventDefault();
                this.createFeature(e.feature);
            })
        }

        this.setState({
            map: map,
            editingEnabled: !this.state.editingEnabled,
            action: action
        });

    }

    createFeature = async (feat) => {

        console.log(feat);
        let rand_str = Math.random().toString(36).substring(7);

        let data = {
            name: `site_${rand_str}`,
            height: this.props.configuration.bts_ht,
            txpwr: this.props.configuration.txpwr,
            geom: `SRID=4326;POINT (${feat.getGeometry().flatCoordinates[0]} ${feat.getGeometry().flatCoordinates[1]})`,
            collection_version: this.props.selectedVersion.pk
        };

        const response_feature = await vanu.post('/sites/', data, {
            headers: { 'Authorization': 'Token ' + this.props.token }
        });

        const collection_version = await vanu.get(`/collectionversions/${response_feature.data.collection_version}`, {
            headers: { 'Authorization': 'Token ' + this.props.token }
        })

        this.props.onEditingCompleted(response_feature.data, collection_version.data);
        console.log('feature created!');
    }

    removeLayers(map, layer_type) {
        var layersToRemove = [];
        map.getLayers().forEach((layer) => {
            if (layer && layer.get('type') === layer_type) {
                layersToRemove.push(layer);
            }
        });
        for (var i = 0; i < layersToRemove.length; i++) {
            map.removeLayer(layersToRemove[i]);
        }
    }

    removeCoverageMap(map) {
        var imgGroup = null;
        map.getLayers().forEach((layer) => {
            if (layer instanceof LayerGroup) {
                imgGroup = layer;
            }
        });
        if (imgGroup) {
            map.removeLayer(imgGroup);
        }
    }

    displayProcess = async (proc) => {

        const response = await axios.get(`${appConfig.static_files.URL}/kml/${proc.uuid}/doc.kml`);

        var map = this.state.map;
        this.removeCoverageMap(map);

        var xml = new XMLParser().parseFromString(response.data);
        var gos = xml.getElementsByTagName('GroundOverlay');

        var kmlImages = [];

        gos.forEach(go => {
            var img_name = go.getElementsByTagName('href')[0].value;
            var north = go.getElementsByTagName('north')[0].value;
            var south = go.getElementsByTagName('south')[0].value;
            var west = go.getElementsByTagName('west')[0].value;
            var east = go.getElementsByTagName('east')[0].value;
            var extent = [west, south, east, north];
            kmlImages.push(this.addImage(`${appConfig.static_files.URL}/kml/${proc.uuid}`, img_name, extent));
        });

        var imgGroup = new LayerGroup({
            title: 'Coverage Map',
            combine: false,
            layers: kmlImages
        });

        map.getLayers().insertAt(-1, imgGroup);

    };

    addImage = (dirname, img_name, extent) => {

        var projection = new Projection({
            code: 'xkcd-image',
            units: 'pixels',
            extent: extent
        });

        var kmlImg = new Image({
            title: img_name.replace(/\.[^/.]+$/, ''),
            type: 'kml_img',
            opacity: this.props.configuration.map_options.processes.opacity / 100,
            source: new ImageStatic({
                attributions: 'Vanu Inc - Splat',
                url: dirname + '/' + img_name,
                projection: projection,
                imageExtent: extent
            })
        });

        return kmlImg;
    };

    componentDidUpdate(prevProps) {

        var map = this.state.map;

        if (!this.props.selectedVersion) {
            return;
        }

        // let's see if the active collection was changed
        if (this.props.selectedVersion && this.props.selectedVersion !== prevProps.selectedVersion) {
            this.addCollection(this.props.selectedVersion.pk);
            return;
        }

        // refreh sites color
        if (this.props.configuration && prevProps.configuration) {
            if (this.props.configuration.map_options !== prevProps.configuration.map_options) {
                console.log('Refreshing map...');
                this.addCollection(this.props.selectedVersion.pk);
                // const sitesColor = this.props.configuration.map_options.sites.color;
                // this.state.map.vectorLayer.setStyle(this.getPointStyle(sitesColor, { r: 255, g: 255, b: 255 }));
            }
        }

        // zoom at
        if (this.props.zoomAt !== prevProps.zoomAt) {
            console.log('Zooming at...');
            map.getView().setCenter(this.props.zoomAt);
            map.getView().setZoom(12);
        }

        // when editing refresh the map
        if (this.state.action === 'editing') {
            map.selectControl.element.childNodes[0].className = "ui icon button mini info-control ol-control";
            map.editControl.element.childNodes[0].className = "ui icon button mini edit-control ol-control active";
            this.state.map.vectorLayer.getSource().refresh()
        } else {
            map.selectControl.element.childNodes[0].className = "ui icon button mini info-control ol-control active";
            map.editControl.element.childNodes[0].className = "ui icon button mini edit-control ol-control";
        };

        // handle selection
        if (this.state.action === 'select' || this.props.activeFeature !== prevProps.activeFeature) {
            var select = map.select_interaction;
            if (select && this.props.activeFeature) {
                var selected_collection = select.getFeatures();
                selected_collection.clear();
                var rows = map.vectorLayer.getSource().getFeatures();
                rows.forEach(row => {
                    if (parseInt(row.getProperties().pk) === this.props.activeFeature) {
                        selected_collection.push(row);
                    }
                })
            }
        }

        // display a process if is needed
        if (this.props.activeProcess && this.props.activeProcess.collection_version.pk === this.props.selectedVersion.pk) {
            this.displayProcess(this.props.activeProcess);
        }

    }

    render() {
        if (!this.props.selectedVersion) {
            return <div></div>
        }
        return (
            <div>
                <div id="map" className="map" data-tut="reactour__map" />
                <div id="popup" className="ol-popup">
                    <a href="#" id="popup-closer" className="ol-popup-closer"></a>
                    <div id="popup-content"></div>
                </div>
            </div>
        )
    }

}

export default MapPanel;
